import React from 'react';

const LocationIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      width="16px"
      height="20px"
      viewBox="0 0 16 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M-1.77635684e-15,15 C-2.79088747e-15,6.71572875 6.71572875,1.52179594e-15 15,0 L388,0 C396.284271,-1.52179594e-15 403,6.71572875 403,15 L403,98 L862,98 C870.284271,98 877,104.715729 877,113 L877,198 C877,206.284271 870.284271,213 862,213 L15,213 C6.71572875,213 1.01453063e-15,206.284271 0,198 L-1.77635684e-15,15 Z"
          id="path-1"
        ></path>
        <filter
          x="-1.8%"
          y="-6.6%"
          width="103.6%"
          height="115.0%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0.780117754   0 0 0 0 0.743163243   0 0 0 0 0.743163243  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="BBdomu.cz_prihlasen" transform="translate(-89, -330)">
          <g id="Group-14" transform="translate(39, 184)">
            <g id="Combined-Shape">
              <use
                fill="black"
                fillOpacity="1"
                filter="url(#filter-2)"
                xlinkHref="#path-1"
              ></use>
              <use fill="#FFFFFF" fillRule="evenodd" xlinkHref="#path-1"></use>
            </g>
            <path
              d="M54.5,127 L602,127 C613.045695,127 622,135.954305 622,147 L622,164 C622,175.045695 613.045695,184 602,184 L54.5,184 C38.7598846,184 26,171.240115 26,155.5 C26,139.759885 38.7598846,127 54.5,127 Z"
              id="Rectangle"
              fill="#E9E4E0"
            ></path>
            <g id="Group-8" transform="translate(39, 137)">
              <circle id="Oval" fill="#5A3218" cx="19" cy="19" r="19"></circle>
              <g
                id="ikon_lokace2"
                transform="translate(11, 9)"
                stroke="#FFFFFF"
                strokeWidth="1.5"
              >
                <g id="Group-5" transform="translate(1.7778, 1.7391)">
                  <path
                    d="M12.1395653,5.93826087 C12.1395653,10.2234783 6.06934307,16.1947826 6.06934307,16.1947826 C6.06934307,16.1947826 -0.00887914895,10.2486957 0,5.93826087 C0,2.65913043 2.71734307,0 6.06934307,0 C9.42223196,0 12.1395653,2.65913043 12.1395653,5.93826087 Z"
                    id="Stroke-1"
                  ></path>
                  <path
                    d="M8.82863196,5.73756522 C8.82863196,7.228 7.59307641,8.43669565 6.06952085,8.43669565 C4.5459653,8.43669565 3.31040974,7.228 3.31040974,5.73756522 C3.31040974,4.24713043 4.5459653,3.03843478 6.06952085,3.03843478 C7.59307641,3.03843478 8.82863196,4.24713043 8.82863196,5.73756522 Z"
                    id="Stroke-3"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LocationIcon;
